import {ServiceBase} from "../ServiceBase";
import {ICompaniesService} from "./companies.service.interface";
import {ICompanyViewModel} from "./modules/company-view-model.interface";


export class CompaniesService extends ServiceBase implements ICompaniesService {
    async getCompanyByName(name: string): Promise<ICompanyViewModel> {
        return await this.services.sdk.getCompanyByName(name);
    }
}